module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('loading-screen', {
    attrs: {
      "show": _vm.displayLoadingScreen,
      "appBackground": true,
      "autoStop": true
    },
    on: {
      "stopLoadingScreen": function($event) {
        _vm.displayLoadingScreen = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-header navbar navbar-fixed-top"
  }, [_c('div', {
    staticClass: "page-header-inner"
  }, [_c('div', {
    staticClass: "page-logo"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "menu-toggler sidebar-toggler",
    on: {
      "click": function($event) {
        _vm.toggleSidebarCollapse()
      }
    }
  }, [_c('span')])]), _vm._v(" "), _vm._m(1), _vm._v(" "), (!_vm.waitingForData) ? _c('div', {
    staticClass: "top-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav pull-right"
  }, [_c('dropdown', {
    attrs: {
      "isLi": true,
      "passedClass": 'dropdown-user'
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "slot": "button",
      "href": "javascript:;",
      "data-toggle": "dropdown",
      "data-hover": "dropdown",
      "data-close-others": "true"
    },
    slot: "button"
  }, [_c('span', {
    staticClass: "username username-hide-on-mobile"
  }, [_vm._v(_vm._s(_vm.activeUser.name.first_name && _vm.activeUser.name.last_name ? ((_vm.activeUser.name.first_name) + " " + (_vm.activeUser.name.last_name)) : 'User'))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, [(_vm.userAccountsLength > 1) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.changeAccount()
      }
    }
  }, [_c('i', {
    staticClass: "icon-users"
  }), _vm._v(" Change Account\n\t\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.logOut()
      }
    }
  }, [_c('i', {
    staticClass: "icon-logout"
  }), _vm._v(" Log Out\n\t\t\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown dropdown-quick-sidebar-toggler width-auto",
    on: {
      "click": function($event) {
        _vm.toggleQuickSidebar($event)
      }
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle location-panel width-auto"
  }, [_vm._m(2), _vm._v(" "), (_vm.activeLocationId) ? _c('div', {
    staticClass: "location-name-container"
  }, [_c('span', {
    staticClass: "business-name"
  }, [_vm._v(_vm._s(_vm.activeBusinessName))]), _vm._v(" "), _c('span', {
    staticClass: "business-location-name"
  }, [_vm._v(_vm._s(_vm.activeLocationName))])]) : _c('div', {
    staticClass: "location-name-container"
  }, [_c('span', {
    staticClass: "business-name big"
  }, [_vm._v(_vm._s(_vm.activeBusinessName))])])])])], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (!_vm.waitingForData) ? _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "page-sidebar-wrapper"
  }, [_c('div', {
    staticClass: "page-sidebar navbar-collapse collapse"
  }, [_c('ul', {
    staticClass: "page-sidebar-menu page-header-fixed",
    attrs: {
      "data-keep-expand": "false"
    }
  }, [_c('li', {
    staticClass: "nav-item start",
    class: {
      'active': _vm.currentRoute === 'dashboard'
    }
  }, [_c('router-link', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "to": "/app/dashboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('span', {
    staticClass: "selected"
  })])], 1), _vm._v(" "), (_vm.activeBusinessId && _vm.activeBusinessId !== 1 && !_vm.activeLocationId) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'my_business'
    },
    attrs: {
      "id": "my_business_link"
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle unselectable",
    on: {
      "click": function($event) {
        _vm.toggleNavigation($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("My Business")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'my_business' && _vm.currentSubRoute === 'users'
    },
    attrs: {
      "id": "my_business_users_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/my_business/users"
    }
  }, [_c('i', {
    staticClass: "fa fa-group"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Users")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'my_business' && _vm.currentSubRoute === 'roles'
    },
    attrs: {
      "id": "my_business_roles_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/my_business/roles"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Roles")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'my_business' && _vm.currentSubRoute === 'regions'
    },
    attrs: {
      "id": "my_business_regions_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/my_business/regions"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Regions")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'my_business' && _vm.currentSubRoute === 'locations'
    },
    attrs: {
      "id": "my_business_locations_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/my_business/locations"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Locations")])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.activeBusinessId && _vm.activeLocationId) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'my_location'
    },
    attrs: {
      "id": "my_location_link"
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle unselectable",
    on: {
      "click": function($event) {
        _vm.toggleNavigation($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("My Location")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'my_location' && _vm.currentSubRoute === 'users'
    },
    attrs: {
      "id": "my_location_users_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/my_location/users"
    }
  }, [_c('i', {
    staticClass: "fa fa-group"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Users")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'my_location' && _vm.currentSubRoute === 'roles'
    },
    attrs: {
      "id": "my_location_roles_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/my_location/roles"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Roles")])])], 1)])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.accessibleApps), function(app) {
    return _c('li', {
      staticClass: "nav-item",
      class: {
        'active': _vm.currentRoute === app.route
      },
      attrs: {
        "id": app.app_id
      }
    }, [(app.id !== 12) ? _c('router-link', {
      staticClass: "nav-link",
      attrs: {
        "to": ("/app/" + (app.route))
      }
    }, [_c('i', {
      staticClass: "fa",
      class: app.fa
    }), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(app.title))])]) : _vm._e(), _vm._v(" "), (app.id === 12) ? _c('a', {
      attrs: {
        "href": ("https://ecomm.staging.unoapp.io/#/login/" + _vm.activeBusinessId + "/" + _vm.v3Token),
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa",
      class: app.fa
    }), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(app.title))])]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.unoappAccount && _vm.activeBusinessId && _vm.activeLocationId) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'unoapp_signage'
    },
    attrs: {
      "id": "unoapp_signage_link"
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle unselectable",
    on: {
      "click": function($event) {
        _vm.toggleNavigation($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Signage")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'unoapp_signage' && _vm.currentSubRoute === 'layout'
    },
    attrs: {
      "id": "unoapp_signage_layout_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/unoapp_signage/layout"
    }
  }, [_c('i', {
    staticClass: "fa fa-group"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Layouts")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'unoapp_signage' && _vm.currentSubRoute === 'playlist'
    },
    attrs: {
      "id": "unoapp_signage_playlist_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/unoapp_signage/playlist"
    }
  }, [_c('i', {
    staticClass: "fa fa-group"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Presentations/Playlists")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'unoapp_signage' && _vm.currentSubRoute === 'content'
    },
    attrs: {
      "id": "unoapp_signage_content_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/unoapp_signage/content"
    }
  }, [_c('i', {
    staticClass: "fa fa-group"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Schedules")])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.unoappAccount) ? _c('li', {
    staticClass: "heading"
  }, [_c('h3', {
    staticClass: "uppercase"
  }, [_vm._v("UNOapp Admin Tools")])]) : _vm._e(), _vm._v(" "), (_vm.unoappAccount) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'unoapp_business'
    },
    attrs: {
      "id": "unoapp_business_link"
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle unselectable",
    on: {
      "click": function($event) {
        _vm.toggleNavigation($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("UNOapp Business")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'unoapp_business' && _vm.currentSubRoute === 'users'
    },
    attrs: {
      "id": "unoapp_business_users_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/unoapp_business/users"
    }
  }, [_c('i', {
    staticClass: "fa fa-group"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Users")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'unoapp_business' && _vm.currentSubRoute === 'roles'
    },
    attrs: {
      "id": "unoapp_business_roles_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/unoapp_business/roles"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Roles")])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.unoappAccount) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'business_manager'
    },
    attrs: {
      "id": "business_manager_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/business_manager"
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Business Manager")])])], 1) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-quick-sidebar-wrapper",
    attrs: {
      "data-close-on-body-click": "false"
    }
  }, [_c('a', {
    staticClass: "page-quick-sidebar-toggler",
    on: {
      "click": function($event) {
        _vm.toggleQuickSidebar($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })]), _vm._v(" "), _c('app-side-panel', {
    on: {
      "updateActiveBusiness": _vm.setActiveBusiness
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.displayImStillHere,
      "effect": "fade"
    },
    on: {
      "update:show": function($event) {
        _vm.displayImStillHere = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Are you still there?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n\t\t\t\tYou've been away from the computer for a while. Let us know if you are still here or you will be logged out.\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.imStillHere()
      }
    }
  }, [_vm._v("I'm still here")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('img', {
    staticClass: "logo-default logo-unoapp",
    attrs: {
      "src": require("../assets/img/app/logo.png"),
      "alt": "logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "menu-toggler responsive-toggler"
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "business-logo",
    attrs: {
      "src": require("../../metronic_src/theme/assets/global/img/portfolio/600x600/01.jpg"),
      "width": "38",
      "height": "38"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c3b365e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 438
// module chunks = 1